import { useEffect, useState } from "react";

import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";

import layoutConf from "../../config/layoutConf";

import TkInputInspectionContainer from "./TkInputInspectionContainer";
import TkInputInspectionDetail from "./TkInputInspectionDetail";

function MomSysInputInspection() {
    const [height, setHeight] = useState();

    const [onSelectMst, setOnSelectMst] = useState();
    const [detailEmpty, setDetailEmpty] = useState();

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [onSelectMst]);

    return (
        <div style={{ height: height }}>
            <ReflexContainer orientation="horizontal">
                <ReflexElement flex={0.5}>
                    <TkInputInspectionContainer
                        id="TkInputInspectionContainer"
                        setOnSelectMst={setOnSelectMst}
                        detailEmpty={detailEmpty}
                    />
                </ReflexElement>

                <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                <ReflexElement flex={0.5}>
                    <TkInputInspectionDetail
                        id="TkInputInspection"
                        onSelectMst={onSelectMst}
                        onEmpty={(isDetailEmpty) => {
                            setDetailEmpty(isDetailEmpty);
                        }}
                    />
                </ReflexElement>
            </ReflexContainer>
        </div>
    );
}

export default MomSysInputInspection;
